import { render, staticRenderFns } from "./UserDiscountPlan.vue?vue&type=template&id=d0fcc936&"
import script from "./UserDiscountPlan.vue?vue&type=script&lang=js&"
export * from "./UserDiscountPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports